export const relTime = (date: Date | string | null | undefined): string => {
  if (!date) return '—';
  const d = date instanceof Date ? date : new Date(date);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const absTime = (date: Date | string | null | undefined): string => {
  if (!date) return '—';
  const d = date instanceof Date ? date : new Date(date);
  return d.toISOString().replace('T', ' ').slice(0, 19) + ' UTC';
};

export const hms = (date: Date | string | null | undefined): string => {
  if (!date) return '—';
  const d = date instanceof Date ? date : new Date(date);
  return d.toISOString().slice(11, 19);
};

export const durBetween = (a: Date | null, b: Date | null): string => {
  if (!a || !b) return '—';
  const ms = Math.abs(b.getTime() - a.getTime());
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.floor(ms / 60000)}m ${Math.round((ms % 60000) / 1000)}s`;
};
